module.exports = __webpack_public_path__ + "img/图片2.deef31a7.png";